import _isNil from 'lodash/isNil'
import GreenStatus from './GreenStatus'
import GreyStatus from './GreyStatus'
import RedStatus from './RedStatus'
import YellowStatus from './YellowStatus'

const colorStatusComponent = [GreenStatus, YellowStatus, RedStatus, GreyStatus]

interface StatusCardProps {
  statusNumber?: number
  statusString?: string
}

function StatusCard({ statusNumber, statusString }: StatusCardProps) {
  if (!_isNil(statusNumber)) {
    const CurrentStatus = colorStatusComponent[statusNumber]
    return <CurrentStatus statusString={statusString} />
  }

  return null
}

export default StatusCard
